export const LOADING_AUTH_STATUS = "LOADING_AUTH_STATUS";
export const RESET_LOADING_STATUS = "RESET_LOADING_STATUS";

export type LoadingActionPayload = {
  type: string;
  payload: any;
};
